import { render, staticRenderFns } from "./MyOrderTicket.vue?vue&type=template&id=6927c1ee&scoped=true&"
import script from "./MyOrderTicket.vue?vue&type=script&lang=js&"
export * from "./MyOrderTicket.vue?vue&type=script&lang=js&"
import style0 from "./MyOrderTicket.vue?vue&type=style&index=0&id=6927c1ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927c1ee",
  null
  
)

export default component.exports